var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-form-item', {
    class: _vm.formClassName,
    attrs: {
      "prop": _vm.formProp,
      "label": _vm.label,
      "rules": _vm.formRule
    }
  }, [_c('el-input', {
    class: _vm.className,
    attrs: {
      "type": _vm.inputType,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "rows": _vm.rows,
      "data-selector": _vm.dataSelector,
      "clearable": _vm.clearable
    },
    on: {
      "change": _vm.onChange,
      "input": _vm.onInput,
      "blur": _vm.onBlur,
      "clear": _vm.onClear
    },
    nativeOn: {
      "keypress": function ($event) {
        return _vm.onKeyPress.apply(null, arguments);
      },
      "keydown": function ($event) {
        return _vm.onKeyDown.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([_vm.prefixIconPath ? {
      key: "prefix",
      fn: function () {
        return [_c('img', {
          attrs: {
            "src": _vm.prefixIconPath
          }
        })];
      },
      proxy: true
    } : null], null, true),
    model: {
      value: _vm.inputValue,
      callback: function ($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  }), _vm._v(" "), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }